/* eslint-disable import/no-anonymous-default-export */
import { FETCH_ALL_STORES } from "../constants/actionTypes";

export default (stores = [], action) => {
  switch (action.type) {
    case FETCH_ALL_STORES:
      return action.payload;
    default:
      return stores;
  }
};
